export default function main(state = {}, action) {
	switch(action.type) {

		case 'SET_TOKENS':
			return {
				...state,
				tokens:action.payload
			}
		
		case 'ADD_TOKEN_CREATED':
			if (state.tokens.find(t=>t.LoyaltyToken.id == action.payload.LoyaltyToken.id)) {
				return state;
			}

			return {
				...state,
				tokens:[
					...state.tokens,
					action.payload
				]
			}

		case 'TOKEN_CREATED':
			return {
				...state,
				tokens:state.tokens.map(token=>{
					if (token.LoyaltyToken.id != 'add') return token;
					return action.payload;
				})
			}
		
		 case 'ADD_TOKEN':
			return {
				...state,
				tokens:[...state.tokens,{LoyaltyToken:{id:'add',title:'',ref:''}}]
			}


		case 'DELETE_TOKEN':
			return {
				...state,
				tokens:state.tokens.filter(b=>b.LoyaltyToken.id != action.payload),
			}

		case 'TRANSLATE': 
			return { 
				...state, 
				tokens:state.tokens.map((field) => {
					if(field.LoyaltyToken.id != action.id) return field;
					if(field.LoyaltyToken.loc == undefined || field.LoyaltyToken.loc=="") field.LoyaltyToken.loc = {};
					if(field.LoyaltyToken.loc[action.loc] == undefined) field.LoyaltyToken.loc[action.loc] = {};
					if(action.v == '' && field.LoyaltyToken.loc[action.loc][action.k] != undefined) {
						delete field.LoyaltyToken.loc[action.loc][action.k];
					} else {
						field.LoyaltyToken.loc[action.loc][action.k] = action.v;
					}
					return {LoyaltyToken:{...field.LoyaltyToken}};
			})}

		case 'CHANGE_TOKEN':
			for (var i in state.tokens) {
				if (state.tokens[i].LoyaltyToken.id != action.id) continue;

				state.tokens[i].LoyaltyToken[action.k] = action.v;
				
				return {
					...state,
					tokens:[...state.tokens]
				}	
			}
			return state;

		default:
			return state;
	}
}

export const loadTokens = (promotion_id,dispatch) => {
	$.get(`/promotions/loyalty_tokens/${promotion_id}`, (response) => {
		dispatch({ type:'SET_TOKENS', payload:response });
	},'JSON')
}

export const createToken = (promotion_id,token,dispatch,cb) => {
	$.post(`/promotions/loyalty_tokens/${promotion_id}`, token, (created) => {
		if(token.LoyaltyToken?.id == 'add') {
			dispatch({ type:'TOKEN_CREATED', payload:created });
		}
		else {
			dispatch({ type:'ADD_TOKEN_CREATED', payload:created });
		}
		if (cb != undefined)cb();
	}, 'JSON');
}